export default __webpack_public_path__ + "static/media/4.0cc13c38.png";